import { cipo } from 'cipo';

cipo.controller('editSovItemController',
    function ($scope, Message, MODAL, SovItem, contractId, sovEntityInstanceId, operations, $q, item, $mdDialog) {

        $scope.modalInfo = MODAL;

        $scope.operations = operations || {};
        $scope.disabledBtn = false;

        $scope.actionBtnDisabled = false;
        $scope.sovEntityInstanceId = sovEntityInstanceId || 0;
        $scope.sovItem = new SovItem(item, contractId, sovEntityInstanceId);

        $scope.revertTabInfo = function () {
            if (!$scope.isModified) $mdDialog.cancel();
            else $mdDialog.hide({ start: $scope.sovItem.initialCategory, end: $scope.sovItem.finalCategory, startWBS: $scope.sovItem.initialWBSNode, endWBS: $scope.sovItem.finalWBSNode });
        };

        $scope.updateTabInfo = function () {
            $scope.hightlight = false;
            $scope.actionBtnDisabled = true;
            $scope.save()
                .then(function (r) {
                    $mdDialog.hide({ start: $scope.sovItem.initialCategory, end: $scope.sovItem.finalCategory, startWBS: $scope.sovItem.initialWBSNode, endWBS: $scope.sovItem.finalWBSNode });
                })
                .catch(function (e) {
                    console.error(e);
                })
                .finally(function () {
                    $scope.actionBtnDisabled = false;
                });
        };

        $scope.cancelAction = function () {
            $scope.tabWarning = false;
            $scope.hightlight = false;
            $scope.disabledBtn = false;
        };


        $scope.save = function (isAddAnother) {
            var p = $q.defer();
            $scope.disabledBtn = true;
            $scope.tabWarning = false;
            $scope.hightlight = false;
            $scope.message = `Saving ${$scope.sovItem.itemName} item...`;
            
            $scope.sovItem.saveWithDelay(
                function () {
                    Message.info(`${$scope.sovItem.itemName} saved successfully`);
                    
                    $scope.disabledBtn = false;
                    $scope.message = "";
                    $scope.disabledBtn = false;
                    $scope.isModified = true;
                    if (isAddAnother) {
                        $scope.sovItem.init();
                        $scope.sovItem.get_itemDetails();
                    } else {
                        $scope.close();
                    }

                    p.resolve();
                },
                function (e) {
                    $scope.disabledBtn = false;
                    $scope.message = "";

                    p.reject(e);
                });

            return p.promise;
        };


        $scope.close = function () {
            if (!$scope.sovItem.screen.form.dirty)
                if (!$scope.isModified) $mdDialog.cancel();
                else $mdDialog.hide({ start: $scope.sovItem.initialCategory, end: $scope.sovItem.finalCategory, startWBS: $scope.sovItem.initialWBSNode, endWBS: $scope.sovItem.finalWBSNode, categoriesArray: $scope.sovItem.categoriesArray });
            else {
                $scope.hightlight = true;
                $scope.tabWarning = true;
            }
        };

    });
